import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getGuestView = get('guest.routes.view');

export const getGuestViewData = createSelector(getGuestView, get('data'));

export const getIsFetching = createSelector(getGuestView, get('fetching'));

export const getIsFetched = createSelector(getGuestView, get('fetched'));

export const getIsDeletingGuest = createSelector(
  getGuestView,
  get('deletingGuest')
);

export const getIsDeletedGuest = createSelector(
  getGuestView,
  get('deletedGuest')
);

export const getIsDeletingMember = createSelector(
  getGuestView,
  get('deletingMember')
);

export const getIsDeletedMember = createSelector(
  getGuestView,
  get('deletedMember')
);
